export const parsePhoneNumber = (countryCodesList?: string, phoneNumber?: string): [string | null, string | null] => {
  if (!phoneNumber || !countryCodesList) {
    return [null, null];
  }

  const parsedCountryCodesList: string[] = countryCodesList.split(",");

  for (const countryCode of parsedCountryCodesList) {
    const phoneNumberWithoutPlus = phoneNumber.replace("+", "");
    const codeWithoutPlus = countryCode.replace("+", "");

    if (phoneNumberWithoutPlus.startsWith(codeWithoutPlus)) {
      return [countryCode, phoneNumberWithoutPlus.slice(codeWithoutPlus.length)];
    }
  }

  return [null, null];
};
